export default {
    "settings": {
        "titles": "Configurações",
        "title": "Configuração",
    },
}

